import { render } from "./MiezzWharfBoxSticker.vue?vue&type=template&id=5b38b2b3&scoped=true&ts=true"
import script from "./MiezzWharfBoxSticker.vue?vue&type=script&lang=ts"
export * from "./MiezzWharfBoxSticker.vue?vue&type=script&lang=ts"

import "./MiezzWharfBoxSticker.vue?vue&type=style&index=0&id=5b38b2b3&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b38b2b3"]])

export default __exports__